function setMinHeightOfItems(items, minHeight) {
    items.forEach((item) => {
        item.style.minHeight = minHeight + 'px';
    });
}

function equalColumns(selector) {
    let minHeight = 0;
    let currentTopPosition = 0;
    let items = [];

    // Go through every found node and set the minimal height to all the elements
    [...document.querySelectorAll(selector)].forEach((element) => {
        // Reset the minimal height
        element.style.minHeight = 0;

        // Get the current position on the page
        const TOP_POSITION = element.getBoundingClientRect().top;

        if (currentTopPosition == TOP_POSITION) {
            // This element is in the current row

            // Add this to the list of items
            items.push(element);

            // Overwrite minimal height of it is taller
            minHeight = Math.max(minHeight, element.offsetHeight);
        } else {
            // This element is in a new row

            // Set all the minimal heights on the completed row
            setMinHeightOfItems(items, minHeight);

            // Set the variables for the new row
            items = [];
            currentTopPosition = TOP_POSITION;
            minHeight = element.offsetHeight;
            items.push(element);
        }
    });

    // As the last row has not a new top position, we have to set this here
    setMinHeightOfItems(items, minHeight);
}

function equalHeights(selector) {
    let animationFrame;
    let timeout;
    window.addEventListener('resize', () => {
        if (animationFrame) {
            window.cancelAnimationFrame(animationFrame);
        }
        if (timeout) {
            window.clearTimeout(timeout);
        }

        animationFrame = window.requestAnimationFrame(() => {
            timeout = setTimeout(() => {
                equalColumns(selector);
            }, 500);
        });
    });

    equalColumns(selector);
}

export default equalHeights;
